const VIDEO_URLS = {
  reel2025Full: {
    src: "https://player.vimeo.com/progressive_redirect/playback/1164471223/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=3248b9c4f6dec233f2f47da03a029a7a71fe7bd22dc5709a9477078c09c92244",
    poster:
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/eoy25-full-poster.jpg",
    alt: "The video features short clips of various eBay Design projects, brand graphics, UX and UI moments, and branded events.",
  },
  reel2025Short: {
    src: "https://player.vimeo.com/progressive_redirect/playback/1164471264/rendition/720p/file.mp4%20%28720p%29.mp4?loc=external&signature=2f38a39f259aa096ad6d03c4679bd47cbee404ebb13116d25dfdc7d6e7442920",
    poster:
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/eoy25-short-poster-2.jpg",
    alt: "The video features short clips of various eBay Design projects, brand graphics, UX and UI moments, and branded events.",
  },
  reelEvo: {
    src: "https://player.vimeo.com/progressive_redirect/playback/1164471288/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=94f9c7efea91301a7f124cb6e64d13da6865b439c7882cd95a0c7f0e038f2881",
    poster:
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/tagline-poster-2.jpg",
    alt: "A brand video combining eBay graphics and UI elements with studio video clips, featuring the tagline “Things. People. Love.”",
  },
  homeHero: {
    src: "https://player.vimeo.com/progressive_redirect/playback/1166059817/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=3cff244ded4378ab0725f2b7e92c29b6a6faa293c38862dba335e9528533dfd8",
    poster:
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/hero-loop-poster.jpg",
    posterPRM:
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/hero-loop-poster-2.jpg",
    alt: "",
  },
};

export { VIDEO_URLS };
